export const RADIO_SCALE = 0.6 as const;

export const RADIO_RIPPLE_SPREAD = "40%" as const;

export const RADIO_LAYOUTS = [
  "default",
  "text",
  "card",
  "list",
  "tile",
] as const;

export const RADIO_INDICATOR_POSITIONS = ["start", "end"] as const;

export const RADIO_ALIGNS = ["start", "center"] as const;

export const RADIO_GROUP_TAG_NAME = "radio-group" as const;

export const RADIO_GROUP_ITEM_TAG_NAME = "radio-group-item" as const;
